import { render, staticRenderFns } from "./gameOut.vue?vue&type=template&id=2c8cec56&scoped=true"
import script from "./gameOut.vue?vue&type=script&lang=js"
export * from "./gameOut.vue?vue&type=script&lang=js"
import style0 from "./gameOut.vue?vue&type=style&index=0&id=2c8cec56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8cec56",
  null
  
)

export default component.exports